import SenseRowSmallBoxSvg from './SenseRowSmallBoxSvg';

export default SenseRowSmallBoxSvg;
